import { makeStyles } from '@mui/styles';
import { Colors } from '../../../assets/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: '20px',
  },
  resourceGroup: {
    '& ul': {
      borderRight: '3px solid',
      borderRightColor: Colors.Blue,
    },
    '&:last-of-type': {
      '& ul': {
        borderRight: 'none',
      },
    },
    // [theme.breakpoints.down('xs')]: {
    //   '& ul': {
    //     borderRight: 'none',
    //   },
    // },
  },
}));

export default useStyles;